import { ArchiveScorecardRowRequest } from "./types";

export const SCORECARD_API_PATHS = {
    DATA: (siteId: number) => `/scorecard/${siteId}`,
    SCORECARD_CONFIG: "/scorecard/config",
    SCORECARD_ROWS: "/scorecard/rows",
    SCORECARD_ROW: (rowId: number) => `/scorecard/rows/${rowId}`,
    ARCHIVE_ROW: (rowId: number, query: ArchiveScorecardRowRequest) => `/scorecard/rows/${rowId}/archive?archived=${query.archived}`,
    DOWNLOAD: (siteId: number) => `/scorecard/download/${siteId}`,
    UPLOAD: "/scorecard/upload",
    TEMPLATES: "/scorecard/rows/templates",
    TEMPLATE: (id: number) => `/scorecard/rows/templates/${id}`,
    CREATE_TEMPLATE_FROM_SITE: (siteId: number) => `/scorecard/rows/templates/${siteId}`,
    CREATE_FROM_TEMPLATE: "/scorecard/rows/templates/create",
    DOWNLOAD_TEMPLATE: (id: number) => `/scorecard/rows/templates/${id}/download`,
    UPLOAD_TEMPLATE: "/scorecard/rows/templates/upload",
    KPI_SUMMARY: "/aggregations/kpi-summary",
    KPI_SUMMARY_EXPORT: "/aggregations/kpi-summary/export",
    NOTES: (dataId: number) => `/scorecard/data/${dataId}/notes`,
    DOCUMENTS: (dataId: number) => `/scorecard/data/${dataId}/documents`,
    DOCUMENT: (documentId: number) => `/scorecard/documents/${documentId}`,
    SITE_FURTHER_INFO: (siteId: number) => `/scorecard/site/${siteId}/further-info`,
    UPDATE_SITE_FURTHER_INFO: "/scorecard/site/further-info",
    ADD_CELL_DATA: "/scorecard/data",
    UPDATE_CELL_DATA: (id: number) => `/scorecard/data/${id}`,
    REVIEW_DATA_CELL: (scorecardDataId: number) => `/scorecard/data/${scorecardDataId}/review`,
    UNREVIEW_DATA_CELL: (scorecardDataId: number) => `/scorecard/data/${scorecardDataId}/unreview`,
    DATA_CELL_DETAILS: (scorecardDataId: number) => `/scorecard/data/${scorecardDataId}`,
};
